import Welkom from "./Welkom.vue"
import BatenLasten from "./BatenLasten.vue"
import BeleidOrganisatie from "./BeleidOrganisatie.vue"
import Bestuur from "./Bestuur.vue"
import Vermogen from "./Vermogen.vue"

export default {
    Welkom,BatenLasten,BeleidOrganisatie,Bestuur,Vermogen
}